import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import { translate } from "react-i18next";
import SelectInput from '../../../../../../components/SelectInput';
import messageManager from '../../../../../../utilities/messageManager';
import loading from '../../../../../../utilities/loading';

class RoleManager extends React.Component<Props, State> {
    constructor(props) {
        super();
        const { t, user, roles } = props;
        const avalibleRoles = [
            { name: 'Admin', alias: t('Admin') },
            { name: 'Expert', alias: t('Expert') },
            { name: 'Regular', alias: t('Regular') },
        ];

        if (roles === 'SuperAdmin')
            avalibleRoles.push({ name: 'SuperAdmin', alias: t('SuperAdmin') })

        const selectedRole = avalibleRoles.find(role => {
            return user.roles[0] === role.name;
        });
        this.state = {
            avalibleRoles: avalibleRoles,
            selectedRole: selectedRole || avalibleRoles[0],
            selectDisabled: false,
        }
    }

    setRole(userId, grantRole) {
        const { BASE_URL, axiosInstance, t, getUsers } = this.props;
        loading.start();

        axiosInstance.post(`${BASE_URL}account/set-role`, { userId: userId, role: grantRole })
            .then(response => {
                getUsers();
                messageManager.show({
                    type: 'info',
                    text: t('User role changed'),
                });
                loading.stop();
                this.setState({ selectDisabled: false });                
            })
            .catch(error => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while changing user role')),
                });
                loading.stop();
                this.setState({ selectDisabled: false });
            });
    }

    render() {
        const { user } = this.props;
        const { avalibleRoles, selectedRole, selectDisabled } = this.state;

        return (
            <td>
                <SelectInput
                    disabled={selectDisabled}
                    defaultValue={selectedRole.name}
                    onChange={(e) => {
                        const selectedRole = avalibleRoles.find(role => {
                            return role.name === e.target.value;
                        })
                        this.setState({
                            selectedRole: selectedRole
                        })
                        this.setRole(user.id, selectedRole.name);
                        this.setState({
                            selectedRole: selectedRole,
                            selectDisabled: true
                        });
                    }}
                    style={{
                        padding: '2px',
                        margin: '0',
                    }}>
                    {avalibleRoles.map(role => {
                        return (
                            <option
                                key={`${role.name}_role_option`}
                                value={role.name}>
                                {role.alias}
                            </option>
                        )
                    })}
                </SelectInput>
            </td>
        )
    }
}

const mapStateToProps = state => ({
    roles: state.auth.get('roles'),
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(RoleManager));



// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/userAdmin/roleManager/RoleManager.jsx